/**
 * SoleadLab 2.0 - Editor Panel (Left Ticket Content)
 *
 * Renders ticket-specific content based on the active left rail ticket.
 * Each ticket is a self-contained component in the tickets/ directory.
 *
 * REFERENCE: editor (23).html - lines 3493-3700
 */

import VectorLayoutTicket from './tickets/VectorLayoutTicket';
import MapTicket from './tickets/MapTicket';
import IndicationsTicket from './tickets/IndicationsTicket';
import ProjectTicket from './tickets/ProjectTicket';
import PlansTicket from './tickets/PlansTicket';
import MediaTicket from './tickets/MediaTicket';
import OrthophotoTicket from './tickets/OrthophotoTicket';
import IVReportingTicket from './tickets/IVReportingTicket';
import StateTicket from './tickets/StateTicket';
import ReviewToolsTicket from './tickets/ReviewToolsTicket';
import './EditorPanel.css';

export default function EditorPanel({ activeTicket }: { activeTicket: string | null }) {
  return (
    <div className="editor-panel">
      {/* ── PROJECT ─────────────────────────────────── */}
      {activeTicket === 'project' && <ProjectTicket />}

      {/* ── MAP ─────────────────────────────────────── */}
      {activeTicket === 'map' && <MapTicket />}

      {/* ── ORTHOPHOTO ──────────────────────────────── */}
      {activeTicket === 'orthophoto' && <OrthophotoTicket />}

      {/* ── PLANS ───────────────────────────────────── */}
      {activeTicket === 'plans' && <PlansTicket />}

      {/* ── VECTOR LAYOUT ─────────────────────────── */}
      {activeTicket === 'vector-layout' && <VectorLayoutTicket />}

      {/* ── MEDIA ───────────────────────────────────── */}
      {activeTicket === 'media' && <MediaTicket />}

      {/* ── INDICATIONS ─────────────────────────────── */}
      {activeTicket === 'indications' && <IndicationsTicket />}

      {/* ── IV REPORTING ─────────────────────────────── */}
      {activeTicket === 'iv-reporting' && <IVReportingTicket />}

      {/* ── SITE STATE ───────────────────────────────── */}
      {activeTicket === 'site-state' && <StateTicket />}

      {/* ── REVIEW TOOLS ──────────────────────────────── */}
      {activeTicket === 'review-tools' && <ReviewToolsTicket />}
    </div>
  );
}
